module.exports = __webpack_public_path__ + "static/media/covid_brazil.d9e7f8c0.pdf";